import { ShieldAlert } from "lucide-react";
import type { ClientAgentMessage } from "@/types/agent";

interface RestrictedBadgeProps {
  messages: ClientAgentMessage[];
}

/**
 * Displays a warning badge when the last assistant message was classified
 * as restricted (tools disabled, human review required).
 */
export function RestrictedBadge({ messages }: RestrictedBadgeProps): React.ReactElement | null {
  const lastAssistant = [...messages].reverse().find((m) => m.role === "assistant");

  if (lastAssistant?.sensitivityTier !== "restricted") return null;

  return (
    <div
      className="flex items-center gap-1.5 px-3 py-1.5 bg-destructive/10 border-b border-destructive/20 text-destructive text-xs"
      data-testid="restricted-badge"
    >
      <ShieldAlert className="h-3.5 w-3.5 shrink-0" />
      <span>Restricted — tools disabled, human review required</span>
    </div>
  );
}
